export enum AggregatedStatus {
  AUTO = "AUTO",
  APPROVED = "APPROVED",
  CLERICAL_ERROR = "CLERICAL_ERROR",
  DECLINED = "DECLINED",
  FRAUD = "FRAUD",
  INCOMPLETE = "INCOMPLETE",
  MISSING_RESPONSE_FROM_CUSTOMER = "MISSING_RESPONSE_FROM_CUSTOMER",
  MISSING_RESPONSE_FROM_DOCTOR = "MISSING_RESPONSE_FROM_DOCTOR",
  NEEDS_CEASED = "NEEDS_CEASED",
  NEW_COMPANY = "NEW_COMPANY",
  NOT_ACCEPTED = "NOT_ACCEPTED",
  NOT_SIGNED = "NOT_SIGNED",
  NTU = "NTU",
  POSTPONED = "POSTPONED",
  REOPENED = "REOPENED",
  RESCINDED = "RESCINDED",
  RIGHT_OF_WITHDRAWAL = "RIGHT_OF_WITHDRAWAL",
  WITHDRAWN = "WITHDRAWN",
  WRONG_SALE = "WRONG_SALE",
  UNKNOWN = "Unknown",
}

export enum Direction {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

export enum Gender {
  Male = "Male",
  Female = "Female",
  Unknown = "Unknown",
}

export enum Status {
  INITIAL = "INITIAL",
  CUSTOMER_INITIALIZED = "CUSTOMER_INITIALIZED",
  SIGN_ORDER_CREATED = "SIGN_ORDER_CREATED",
  CUSTOMER_COMPLETED = "CUSTOMER_COMPLETED",
  AWAITING_CUSTOMER_RESPONSE = "AWAITING_CUSTOMER_RESPONSE",
  AWAITING_CUSTOMER_COMPLETED = "AWAITING_CUSTOMER_COMPLETED",
  AWAITING_THIRD_PARTY = "AWAITING_THIRD_PARTY",
  AWAITING_THIRD_PARTY_COMPLETED = "AWAITING_THIRD_PARTY_COMPLETED",
  AWAITING_FINALIZE_LETTER = "AWAITING_FINALIZE_LETTER",
  MANUAL_UNDERWRITING = "MANUAL_UNDERWRITING",
  COMPLETED = "COMPLETED",
  EXPIRED = "EXPIRED",
  CANCELLED = "CANCELLED",
}

export enum RiskType {
  LIFE_PRIVATE = "LIFE_PRIVATE",
  LIFE_COLLECTIVE = "LIFE_COLLECTIVE",
  CRITICAL_ILLNESS_PRIVATE = "CRITICAL_ILLNESS_PRIVATE",
  CRITICAL_ILLNESS_COLLECTIVE = "CRITICAL_ILLNESS_COLLECTIVE",
  DISABILITY_UP = "DISABILITY_UP",
  DISABILITY_UR = "DISABILITY_UR",
  DISABILITY_EU = "DISABILITY_EU",
  DISABILITY_UK = "DISABILITY_UK",
  DISABILITY_BM = "DISABILITY_BM",
  SICK_INTERRUPTED = "SICK_INTERRUPTED",
  CHILD_PRIVATE = "CHILD_PRIVATE",
  CHILD_COLLECTIVE = "CHILD_COLLECTIVE",
  UNKNOWN = "UNKNOWN",
}

export enum ReminderStatus {
  REMINDER_1 = "REMINDER_1",
  REMINDER_2 = "REMINDER_2",
  REMINDER_3 = "REMINDER_3",
}

export interface Attachment {
  direction: Direction;
  identifier: string;
  name: string;
}

export interface Person {
  firstName: string;
  lastName: string;
  nin: string;
}

export interface Customer {
  personDto: Person;
}

export interface Exclusion {
  code: string;
  text: string;
}

export interface EvidenceRequirement {
  attachments: Attachment[];
  caseId: string;
  customerEvidenceType: EvidenceType;
  customerMessage: string;
  customerMessageTitle: string;
  customerRead: boolean;
  customerResponse: string;
  evidenceId: string;
  evidenceStatus: EvidenceStatus;
  requirementSentBy: string;
  requirementSentDate: string;
  requirementUploadedBy: string;
  requirementUploadedDate: string;
}

export enum EvidenceStatus {
  CANCELLED = "CANCELLED",
  CREATED = "CREATED",
  SENT = "SENT",
  RECEIVED = "RECEIVED",
  COMPLETED = "COMPLETED",
}

export enum EvidenceType {
  ONE_WAY = "ONE_WAY",
  TWO_WAY = "TWO_WAY",
  TWO_WAY_WITH_ATTACHMENTS = "TWO_WAY_WITH_ATTACHMENTS",
}

export interface Loading {
  text: string;
  value: number;
}

export interface Risk {
  exclusions: Exclusion[];
  loading: Loading;
  status: Status;
  type: RiskType;
}

export enum InsuranceSubType {
  CHILD_P_BASIS = "CHILD_P_BASIS",
  CHILD_P_EKSTRA = "CHILD_P_EKSTRA",
  CHILD_P_TOTAL = "CHILD_P_TOTAL",
}

export interface Insurance {
  cancelled: boolean;
  cancelledBy?: string;
  cancelledDate?: string;
  existingAlisPolicies: string[];
  existingF2100Policies: string[];
  externalReference: string;
  id: number;
  insuranceSubType: InsuranceSubType;
  name: string;
  risks: Risk[];
}

export interface Case {
  aggregatedStatus?: AggregatedStatus;
  cancellationText?: string;
  caseId: string;
  creationDateTime: string;
  customer: Customer;
  expiresDateTime: string;
  evidences: EvidenceRequirement[];
  finalizedLetterIdentifier?: string;
  gender: Gender;
  insurances: Insurance[];
  insured: Person;
  reminderStatus: ReminderStatus;
  status: Status;
}
